export default __webpack_public_path__ + "static/media/main-img1-2.350514a1.png";